export const SHIPPING_PARTNER_INFO = {
  GHN: {color: "#E38225", wildcard: "N"},
  GHTK: {color: "#41BA7C", wildcard: "T"},
  JNTP: {color: "#EE1C25", wildcard: "J"},
  LWE: {color: "#1E7029", wildcard: "T"},
  SHIPPO: {color: "#029240", wildcard: "O"},
  SNAPPY: {color: "#1E2A4F", wildcard: "S"},
  GOSHIP: {color: "#ba1321", wildcard: "G"},
  JNTVN: {color: "#EE1C25", wildcard: "J"},
};